import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, FormGroupDirective, NgForm, Validators, FormControl} from '@angular/forms';
import {CellEditorComponentBase} from '@shared/components/cell-components/cell-component';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {select, Store} from '@ngrx/store';
import {takeUntil} from 'rxjs/operators';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {Subject} from 'rxjs';
import {QueryProvider} from '@shared/queries/query-provider';

@Component({
    standalone: false,
    selector: 'particle-address-cell-editor',
  templateUrl: './address-cell-editor.component.html',
  styleUrls: ['./address-cell-editor.component.css']
})
export class AddressCellEditorComponent extends CellEditorComponentBase implements OnInit, AfterViewInit, OnDestroy {
  addressForm: any;
  addressFormErrors: any;
  countryList: any[];
  private ngUnsubscribe$ = new Subject<void>();

  constructor(private formBuilder: FormBuilder,
              private queryStore: Store<IQueryState>) {
    super();
    this.addressForm = this.formBuilder.group({
      Street: [''],
      BuildingIdentifier: [''],
      SuiteIdentifier: [''],
      FloorIdentifier: [''],
      DistrictName: [''],
      PostOfficeBoxPOB: [''],
      PostCode: [''],
      City: ['', Validators.required],
      Country: ['', Validators.required]
    });
    this.addressFormErrors = {
      City: {},
      Country: {}
    };
  }

  ngOnInit() {
    this.addressForm.patchValue({
      Street: this.getFormFieldValue('Street'),
      BuildingIdentifier: this.getFormFieldValue('BuildingIdentifier'),
      SuiteIdentifier: this.getFormFieldValue('SuiteIdentifier'),
      FloorIdentifier: this.getFormFieldValue('FloorIdentifier'),
      DistrictName: this.getFormFieldValue('DistrictName'),
      PostOfficeBoxPOB: this.getFormFieldValue('PostOfficeBoxPOB'),
      PostCode: this.getFormFieldValue('PostCode'),
      City: this.getFormFieldValue('City')
    });
    this.addressForm.valueChanges.subscribe(() => {
      this.onAddressFormValuesChanged();
    });
    this.queryStore.pipe(takeUntil(this.ngUnsubscribe$), select(getQueryResponse, 'Dac6-CountryCode-Config')).subscribe(response => {
        if (response && response.items) {
          this.countryList = response.items;
          const countryCode = this.getCountryCode();
          if (countryCode) {
            this.addressForm.patchValue({
              Country: countryCode
            });
          }
        }
    });
    QueryProvider.invokeQuery(this.queryStore, 'Dac6-CountryCode-Config', {});
  }

  private getCountryCode() {
    if (this.item.cells[this.fieldDefinition.key] &&
      this.item.cells[this.fieldDefinition.key].value &&
      this.item.cells[this.fieldDefinition.key].value.fieldValues &&
      this.item.cells[this.fieldDefinition.key].value.fieldValues['Country']) {
        return this.item.cells[this.fieldDefinition.key].value.fieldValues['Country'];
    }
    return null;
  }

  onAddressFormValuesChanged() {
    for (const field in this.addressFormErrors) {
      if (!this.addressFormErrors.hasOwnProperty(field)) {
        continue;
      }
      this.addressFormErrors[field] = {};
      const control = this.addressForm.get(field);
      if (control && control.dirty && !control.valid) {
        this.addressFormErrors[field] = control.errors;
      }
    }
    this.validationChange.emit(this.addressForm.valid);
    this.item.cells = {
      ...this.item.cells,
      'Address': this.getAddressData()
    };
    this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition});

  }
  onOkClicked(): boolean {
    return true;
  }
  ngAfterViewInit(): void {
    this.addressForm.patchValue({
      Street: this.getFormFieldValue('Street'),
      BuildingIdentifier: this.getFormFieldValue('BuildingIdentifier'),
      SuiteIdentifier: this.getFormFieldValue('SuiteIdentifier'),
      FloorIdentifier: this.getFormFieldValue('FloorIdentifier'),
      DistrictName: this.getFormFieldValue('DistrictName'),
      PostOfficeBoxPOB: this.getFormFieldValue('PostOfficeBoxPOB'),
      PostCode: this.getFormFieldValue('PostCode'),
      City: this.getFormFieldValue('City'),
      Country: this.getFormFieldValue('Country')
    });
  }

  private getFormFieldValue(fieldKey: string): string {
    if (this.item.cells[this.fieldDefinition.key] &&
      this.item.cells[this.fieldDefinition.key].value &&
      this.item.cells[this.fieldDefinition.key].value.fieldValues &&
      this.item.cells[this.fieldDefinition.key].value.fieldValues[fieldKey]) {
      return this.item.cells[this.fieldDefinition.key].value.fieldValues[fieldKey];
    }
    return '';
  }
  private getAddressData() {
    if (this.item.cells[this.fieldDefinition.key]) {
      return {
        ...this.item.cells[this.fieldDefinition.key],
        value: {
          fieldValues: this.addressForm.value
        }
      };
    } else {
      return {
        value: {
          fieldValues: this.addressForm.value
        }
      };
    }
  }
  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
